require('./locations_select')
import {confirmPlus} from 'admin/common/custom_confirm'
require("admin/groups/group_users")
require("./branding/branding_page")
require("./group_audio_management")
require("./group_webhook_management")
require("./tags_manager")
import {GroupMessagingManager} from "./group_messaging_manager"
require("admin/locations/industries_select")
import {GroupInactivateModal, GroupReactivate} from "./group_inactivate"
import { IntegrationManagement } from './integration_management'
import {BillingManager} from "./billing_management"
import {GroupBilling} from "./group_billing"
import {Permissions} from "utils/permissions"
import { PhoneManagement } from './phone_management'
import { PBXCallFlowTreatment } from '../pbx_treatments/pbx_call_flow_treatments'
import './default_settings';

export class GroupAdmin extends HTMLElement {
  constructor(group_id, is_admin, group_changed = () => {}, show_inactive) {
    super()
    this.group_id = group_id;
    this.is_admin = is_admin;
    this.group_changed = group_changed;
    this.show_inactive = show_inactive;
  }

  async connectedCallback() {
    let res = await (fetch(`/admin/groups/${this.group_id}`, {
          headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')},
          method: 'GET'
        }).catch(handleError))
    this.data = await res.json();
    let inactive_group = this.data.inactive_date != null && moment.utc(this.data.inactive_date).isBefore(moment.utc());
    
    this.innerHTML = `
      <div class="row">
        <div class="col-md-12">
          <div id='lead_details_results'> 
            <div class="panel-heading">
              <h3><span class="fa fa-cloud"></span> Edit Group: <span class="group_name_title"></span></h3>
            </div>
          </div>
        </div>
      </div>
      <br/><br/>
      <div class="row ${inactive_group ? "group_is_inactive" : ""}">
        <div class="col-md-12">
          <div class="container-fluid">
            <input type='hidden' id='object_id' value='${this.group_id}' />
            <div class="row">
               <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 no-gutters">
                  <div class="nav-tabs page-tabs page-grouptabs page-content-wrap nav" role="tablist" id='tablist'>
                    <a class="active" href="#settings_tab" role="tab" data-toggle="tab">Groups and Locations</a>
                    <a href="#users_tab" role="tab" data-toggle="tab">Users</a>
                    <a href="#branding_tab" role="tab" data-toggle="tab">Branding</a>
                    <a href="#audio_tab" role="tab" data-toggle="tab">Audio</a>
                    <a href="#webhook_tab" role="tab" data-toggle="tab">Integration Templates</a>
                    <a href="#tags_tab" role="tab" data-toggle="tab">Tags</a>
                    <a href="#messaging_tab" role="tab" data-toggle="tab">Messaging</a>
                    ${await Permissions.hasPermissionForGroup(Permissions.ALL.admin_group_phone_management_edit, this.group_id) ? `<a href="#phone_management" role="tab" data-toggle="tab">Phone Management</a>` : ``}
                    ${await Permissions.hasPermissionForGroup(Permissions.ALL.admin_group_accounting_view, this.group_id) ? `<a href="#billing_tab" role="tab" data-toggle="tab">Billing</a>` : ``}
                    <a href="#default_settings_tab" role="tab" data-toggle="tab">Default Settings</a>
                  </div>
                  <div class="panel-body tab-content no-gutters">
                    <div class="page-content-wrap page-tabs-item  tab-pane active" id="settings_tab">
                      
                    </div> <!-- setttings tab -->
                    <div class="page-content-wrap page-tabs-item tab-pane" id="users_tab">
                      <group-users ${this.is_admin ? 'data-is_admin=true' : ''}></group-users>
                    </div>
                    <div class="page-content-wrap page-tabs-item tab-pane" id="branding_tab">
                      <branding-page></branding-page>
                    </div>
                    <div class="page-content-wrap page-tabs-item tab-pane" id="audio_tab">
                      <group-audio></group-audio>
                    </div>
                    <div class="page-content-wrap page-tabs-item tab-pane" id="webhook_tab">
                    </div>
                    <div class="page-content-wrap page-tabs-item tab-pane" id="tags_tab">
                      <tags-manager></tags-manager>
                    </div>
                    <div class="page-content-wrap page-tabs-item tab-pane" id="messaging_tab">
                    </div>
                    ${await Permissions.hasPermissionForGroup(Permissions.ALL.admin_group_phone_management_edit, this.group_id) ? `
                    <div class="page-content-wrap page-tabs-item tab-pane" id="phone_management">
                    </div>
                    ` : ``}
                    ${await Permissions.hasPermissionForGroup(Permissions.ALL.admin_group_accounting_view, this.group_id) ? `
                    <div class="page-content-wrap page-tabs-item tab-pane" id="billing_tab">
                    </div>
                    ` : ``}
                    <div class="page-content-wrap page-tabs-item tab-pane" id="default_settings_tab">
                      <default-settings></default-settings>
                    </div>
                  </div>
              </div> 
            </div>                               
          </div>
        </div>
      </div>
    `

    $(this).find(".page-grouptabs a").on("click",function(e){
        $(this).find(".page-tabs a").removeClass("active");
        $(e.target).addClass("active");
        $(this).find(".page-tabs-item").removeClass("active");
        $($(e.target).attr("href")).addClass("active");
        return false;
    }.bind(this));
    
    this.loadGroup();
  }

  async loadGroup() {
    const isAdmin = await Permissions.hasPermissionForGroup(
      Permissions.ALL.admin_is_admin,
      this.group_id
    );

    const groupName = isAdmin ? `${this.data.name} (${this.group_id})` : this.data.name;
    
    this.querySelector(".group_name_title").innerHTML = groupName;

    this.querySelector("#settings_tab").appendChild(new GroupSettingsTab(this.data, this.updateGroupName.bind(this), this.connectedCallback.bind(this)))

    this.querySelector("#settings_tab").appendChild(new GroupSubGroups(this.data, this.group_changed, this.show_inactive))
    this.querySelector("#settings_tab").appendChild(new GroupLocations(this.data, this.group_changed, this.show_inactive))
    
    if(await Permissions.hasPermissionForGroup(Permissions.ALL.admin_group_accounting_view, this.data.id)) {
      if(this.data.is_callsource_owned) {
        this.querySelector("#billing_tab").appendChild(new GroupBilling(this.data, this.is_admin))  
      } else {
        if(await Permissions.hasPermissionForGroup(Permissions.ALL.admin_group_accounting_edit, this.data.id)) {
          this.querySelector("#billing_tab").appendChild(new BillingManager(this.data, this.is_admin))
        } else {
          this.querySelector("#billing_tab").innerHTML = "<h4>Sorry at this time you do not have permission to see this.</h4>";
        }
      }
    }

    this.querySelector("#messaging_tab").appendChild(new GroupMessagingManager(this.data))
    this.querySelector("#webhook_tab").appendChild(new IntegrationManagement(this.data, this.is_admin))
    this.querySelector("#phone_management").appendChild(new PhoneManagement(this.data.id))
  }

  async updateGroupName(new_name) {
    let res = await (fetch(`/admin/groups/${this.group_id}`, {
          headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-Type': 'application/json'},
          method: 'PATCH',
          body: `{"name":"${new_name}"}`
        }).catch(handleError))
    let data = await res.json();

    if(data.error == null) {
      Common.notify("Updated group name successfully", "success");
      this.querySelector(".group_name_title").innerHTML = new_name;
      this.group_changed(new_name);
    } else {
      Common.notify(data.error, "error");
    }
  }
}

customElements.define("group-admin", GroupAdmin);

class GroupSettingsTab extends HTMLElement {
  constructor(group, save_callback, reload_callback) {
    super()
    this.group = group
    this.save_callback = save_callback;
    this.reload_callback = reload_callback;
  }

  async connectedCallback() {
    let binder = new DataBinder(`/admin/groups/${this.group.id}/permissions`, true)
    await binder.fetchData();
    this.permissions = binder.data;

    this.innerHTML = `
      <style>
      
        group-settings-tab {
          display: flex;
          margin-bottom: 20px;
        }

        group-settings-tab .btn-outline-secondary,
        group-sub-groups .btn-primary,
        group-locations .btn-primary {
          margin-left: 10px;
          min-width: calc(100% - 10px);
        }

        .frame {
          margin: 12px 2px 20px 1px;
          padding: 17px 12px 20px;
          border-radius: 6px;
          border: solid 1px #ccc;
          display: block;
        }

        .group-name-container{
          width: 100%;
          flex-direction: column;
        }

        .btn-group>.dropdown-menu {
          font-size: 13px;
          min-width: 120px;
          z-index: 1;
          appearance: none;
          top: 25px;
        }

        .btn-group>.dropdown-menu>.active>a, .dropdown-menu>.active>a:hover, .dropdown-menu>.active>a:focus {
          background-color:black !important;
          color:#f4f4f4;
        }
  
        .btn-group>.dropdown-menu> li> a:hover{
          background-color:#f4f4f4 !important;
        }

        .caret-off::before {
          display: none;
        }

        .caret-off::after {
          display: none;

      </style>
      <div class="group-name-container">



        <div class="frame form-group form-horizontal col-xs-12">
          <div class="errors"></div>
          <h4>
            Group Name
          </h4>

          <div class="col-sm-10 no-gutters">
            <input class="form-control" id="group_update_name_input" placeholder="Group Name" type="text" name="tag_name" value="${this.group.name}"></div>
          <div class="col-sm-2 no-gutters">
            <a class="btn btn-outline-secondary" id="group_update_name" data-cy="group_name_btn">Update Name</a></div>
        </div>

        <!--div class="col-sm-2 no-gutters pull-right">
        <button type="button" class="btn btn-outline-secondary pull-right ${'on'}" id="inactive-btn" data-cy="inactive-btn">Show Inactive</button>
        </div-->



      </div>
      

      
    `

    // Cannot cancel AUTOID Master
    if(this.group.id != 1){
      if(this.permissions.includes("admin:accounting:can_inactivate_group") && this.group.inactive_date == null) {
        this.querySelector(".group-name-container").prepend(new GroupInactivateModal(this.group, this.reload_callback))
      } else if (this.group.inactive_date != null){
        this.querySelector(".group-name-container").prepend(new GroupReactivate(this.group, this.permissions, this.reload_callback))
      }
    }
    this.querySelector("#group_update_name").addEventListener("click", this.updateGroupName.bind(this))
  }

  updateGroupName() {
    let value = this.querySelector("#group_update_name_input").value.trim();
    if(value.length > 0) {
      this.save_callback(value)
    } else {
      Common.notify("Unable to save blank name.", "warning")
    }
  }
}

customElements.define("group-settings-tab", GroupSettingsTab);

class GroupSubGroups extends HTMLElement {
  constructor(group, group_changed, show_inactive) {
    super();
    this.group = group;
    this.group_changed = group_changed;
    this.show_inactive = show_inactive;
  }

  connectedCallback() {
    this.innerHTML = `
    <style>
      group-sub-groups {
        display: flex;
        margin-bottom: 20px;
      }
      group-sub-groups td {
        padding: 10px 0px;
      }
    </style>
    <div class="form-group form-horizontal col-xs-12">
      <h4>
        Sub Groups
      </h4>

      <div class="col-sm-10 no-gutters">
        <input class="form-control" type="text" name="group-name" placeholder="Group Name"></select>
      </div>
      <div class="col-sm-2 no-gutters">
        <a class="btn btn-primary pull-right add-group">Add Group</a>
      </div>

      <table class="table-striped" style="width: 100%">
        <tbody>

        </tbody>
      </table>
    </div>`

    let groups = this.show_inactive ? this.group.sub_auto_groups : this.group.sub_auto_groups.filter(group => group.inactive_date == null || moment.utc(group.inactive_date).isAfter(moment.utc()));

    this.dataTable = $(this.querySelector("table")).DataTable({
      dom: 'tp',
      data: groups,
      rowId: 'id',
      columns: [{
        data: "name"
      }],

      "fnDrawCallback": function(oSettings) {
          var api = this.api();
          if (api.rows().count() < 11) {
              $('group-sub-groups').find('.dataTables_paginate').hide();
          }
          $('group-sub-groups').find('thead').hide();
      },
      "language": {
        "emptyTable": "No Sub Groups."
      }
    });

    this.querySelector("a.add-group").addEventListener("click", async function() {
      let group_name = this.querySelector("input").value;
      if(group_name.trim().length <= 0) {
        Common.notify("No group name entered.", "warning")
        return;
      }

      let resp = await (fetch(`/admin/groups/${this.group.id}/sub_group`, {
          headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-Type': 'application/json'},
          method: 'POST',
          body:  `{"name":"${group_name}"}`
        }).catch(handleError))
      
      if(resp.ok) {
        let json = await resp.json();

        if(json.error == null) {
          Common.notify('Sub Group successfully added to Group', 'success');
          this.group_changed();
          this.dataTable.rows.add([json]).draw();
        } else {
          Common.notify(json.error, 'error');
        }
      }
      else {
        Common.notify('Failed to add Location to Group', 'error');
      }
    }.bind(this));
  }
}

customElements.define("group-sub-groups", GroupSubGroups);

class GroupLocations extends HTMLElement {
  constructor(group, group_changed, show_inactive) {
    super();
    this.group = group;
    this.group_changed = group_changed;
    this.show_inactive = show_inactive;
  }

  async connectedCallback() {
    let binder = new DataBinder(`/admin/groups/${this.group.id}/permissions`, true)
    await binder.fetchData();
    let permissions = binder.data;

    this.innerHTML = `
    <style>
      group-locations td {
        padding: 3px 0px;
      }
      group-locations tr td:last-child {
        text-align: right;
      }
      group-locations input[type="search"] {
        margin-top: 10px;
      }
      .location_link:hover {
        cursor: pointer;
      }
    </style>
    <div class="form-group form-horizontal col-xs-12">
      <h4 class="col">
        Locations
      </h4>
      <div class="col-sm no-gutters" style="flex-direction:row">
        <a class="btn btn-primary pull-right group-row-button" data-toggle="modal" data-target="#addLocationToGroup" style="min-width:0; padding: 4px 38px; margin: 5px 0px 5px 10px">Add Location</a>
      </div>
      <table class="${permissions.includes("admin:is_admin") ? "table vertical-middle" : "table-striped"}" style="width: 100%">
        <thead class="${permissions.includes("admin:is_admin") ? "" : "hidden"}">
          <tr>
            <th>Location Name</th>
            <th>Location ID</th>
            <th>Call Processing</th>
            <th>EveryLead</th>
            <th>Edit Location</th>
          </tr>
        </thead>
        <tbody>

        </tbody>
      </table>
    </div>`

    this.appendChild(new AddLocationModal(this.addNewLocation.bind(this), this.addExistingLocation.bind(this), this.group));

    let locations = this.show_inactive ? this.group.auto_group_locations : this.group.auto_group_locations.filter(location => location.inactive_date == null || moment.utc(location.inactive_date).isAfter(moment.utc()));

    this.dataTable = $(this.querySelector("table")).DataTable({
      dom: 'Bftp',
      data: locations,
      rowId: 'id',
      columns: [{
        data: "location_name", "searchable":true,
        "render": function ( data, type, row ) {
          return `<a class="location_link">${data}${permissions.includes("admin:is_admin") ? ` (${row.domain_id})` : ''}</a>`
        }
      },
      { data: 'domain_id', visible: false },
      {
        data: "call_processing_queue_type_id", "searchable":true,
        render: function (data, type, row) {
          if (type === 'display') {
            return `<span class="fa ${data != null ? 'fa-check' : 'fa-times'}"></span>`;
          } else if (type === 'export') {
            return data != null ? 'Yes' : 'No';
          } else {
            return data;
          }
        },
        "class": "text-center",
        visible: permissions.includes("admin:is_admin")
      },
      {
        data: "every_lead_package", "searchable":true,
        "render": function ( data, type, row ) {
          let value = "";
          switch(data) {
            case 1:
              value = "Attributed"
              break;
            case 2:
              value = "Analyzed"
              break;
            case 3:
              value = "Optimized"
              break;
          }
          return value;
        },
        "class": "text-center",
        visible: permissions.includes("admin:is_admin")
      },
      {
        render: function() {
          return "<a class='btn btn-line edit_location' style='padding: 4px 32px'>Edit Location</a>"
        }
      }],

      "fnDrawCallback": function(oSettings) {
          var api = this.api();
          if (api.rows().count() < 11) {
              $('group-locations').find('.dataTables_paginate').hide();
          }
          if(!permissions.includes("admin:view")) {
            $('group-locations').find('thead').hide();
          }
      },
      "language": {
        "emptyTable": "No locations under this group."
      },
      buttons: [
        {
          extend: 'excelHtml5',
          text: 'Export Data',
          title: `Locations for ${this.group.name}`,
          exportOptions: {
            columns: 'th:not(:last-child)',
            orthogonal: 'export'
          },
        },
      ],
    });

    this.dataTable.on('click', 'tr td a.remove-group', function (e) {
      let tr = $(e.target).closest('tr')
      let row_data = this.dataTable.row(tr).data();
      this.removeLocation(row_data, tr);
    }.bind(this));

    this.dataTable.on('click', 'tr td a.location_link, tr td a.edit_location', function (e) {
      let tr = $(e.target).closest('tr')
      let row_data = this.dataTable.row(tr).data();
      window.location.href = `/admin/domains/${row_data.domain_id}/edit`;
    }.bind(this));
  }

  async removeLocation(data, row) {
    if(await confirmPlus('Are you sure you want to remove this location from the group?')) {
      let body = {site_id: data.id};
      let resp = await fetch(`/admin/groups/${this.group.id}/location`, {
        method: 'DELETE',
        headers: {
          'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
      })
      if(resp.ok) {
        let json = await resp.json();
        if(json.error == null) {
          Common.notify('Location removed from group', 'success');
          this.group_changed();
          this.dataTable.row(row).remove().draw();
        } else {
          Common.notify(json.error, 'error');
        }
      }
      else {
        Common.notify('Failed to remove user', 'error');
      }
    }
  }

  async addExistingLocation(location_id) {
    let resp = await (fetch(`/admin/groups/${this.group.id}/location`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                'Content-Type': 'application/json'},
        method: 'PUT',
        body: `{"site_id":${location_id}}`
      }).catch(handleError))
    
    if(resp.ok) {
      let json = await resp.json();

      if(json.error == null) {
        Common.notify('Location successfully added to Group', 'success');
        this.group_changed();
        this.dataTable.rows.add(json).draw();
      } else {
        Common.notify(json.error, 'error');
      }
    }
    else {
      Common.notify('Failed to add Location to Group', 'error');
    }
  }

  async addNewLocation(location_name, location_industry) {
    let post_data = {
        domain: {
          site_attributes: {location_name: location_name, auto_group_ids: [this.group.id], owner_auto_group_id: this.group.id},
          industry_id: location_industry,
          web_analytics: 0 // Disable web analytics
        }
      }

    let resp = await (fetch(`/admin/groups/${this.group.id}/location`, {
          headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-Type': 'application/json'},
          method: 'POST',
          body: JSON.stringify(post_data)
        }).catch(handleError))
      
      if(resp.ok) {
        let json = await resp.json();

        if(json.error == null) {
          Common.notify('Location successfully addded to Group', 'success');
          this.group_changed();
          this.dataTable.rows.add(json).draw();
        } else {
          Common.notify(json.error, 'error');
        }
      }
      else {
        Common.notify('Failed to add Location to Group', 'error');
      }
  }
}

customElements.define("group-locations", GroupLocations);

class AddLocationModal extends HTMLElement {
  constructor(addNewLocation, addExistingLocation, group) {
    super();
    this.addExistingLocation = addExistingLocation;
    this.addNewLocation = addNewLocation;
    this.group = group;
  }

  connectedCallback() {
    this.innerHTML = `
    <style>
    add-location-modal {
      font-size: 14px;
    }
    </style>
    <div class="modal fade" id="addLocationToGroup" tabindex="-1">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Add Location to ${this.group.name}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            
          </div>
        </div>
      </div>
    </div>`

    $(this).find('.modal').on('hidden.bs.modal', function () {
      this.reset();
    }.bind(this));

    this.reset();
  }

  reset() {
    this.querySelector('.modal-body').innerHTML = `<div class="row">
        <div class="col-sm-12">
          <p>Choose if you would like to Add a New Location or Move an Existing Location</p>
          <div class="col-sm-offset-4 col-sm-4">
            <a class="btn btn-outline-primary col-sm-12" id="group-new-location">New Location</a>
          </div>
          <div class="col-sm-12" style="text-align:center;">
            or
          </div>
          <div class="col-sm-offset-4 col-sm-4">
            <a class="btn btn-outline-primary col-sm-12" id="group-existing-location">Move Existing Location</a>
          </div>
      </div>`;

      this.querySelector("#group-new-location").addEventListener("click", function() {
        this.newLocation();
      }.bind(this));

      this.querySelector("#group-existing-location").addEventListener("click", function() {
        this.existingLocation();
      }.bind(this));
  }

  newLocation() {
    this.querySelector('.modal-body').innerHTML = `<div class="row">
              <div class="col-sm-12">
                <div class="errors"></div>
                <div class="form-group" style="clear:both;">
                  <label>Choose location</label>
                  <input id="location-name" type="text" class="form-control" placeholder="Name">
                </div>
                <div class="form-group" style="clear:both;">
                  <label>Industry</label>
                  <select id="location-industry" is="industries-select" class="form-control"></select>
                </div>
                <div class="form-group" style="overflow:auto;">
                  <a id="new-location-save" type=submit value='Save' class='btn btn-primary pull-right detail-row-button' style="min-width:0">Add Location</a><a data-dismiss="modal" class='btn btn-outline-secondary pull-right detail-row-button'>Cancel</a>
                </div>
              </div>
            </div>`

    this.querySelector("#new-location-save").addEventListener("click", function() {
      let errors = "";
      let location_name = this.querySelector("#location-name").value.trim()
      let location_industry = this.querySelector("#location-industry").value
      if(location_name.trim().length == 0) {
        errors += `<div class="alert alert-danger alert-dismissible" role="alert">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>Warning!</strong> Please provide a location name.
        </div>`;
      }
      if(location_industry == 'null') {
        errors += `<div class="alert alert-danger alert-dismissible" role="alert">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>Warning!</strong> Please provide an Industry.
        </div>`;
      }

      if(errors.length > 0) {
        this.querySelector(".errors").innerHTML = errors;
        return;
      }

      $(this).find('.modal').modal('hide');
      this.addNewLocation(location_name, location_industry)
    }.bind(this));
  }

  existingLocation() {
    this.querySelector('.modal-body').innerHTML = `<div class="row">
              <div class="col-sm-12">
                <div class="errors"></div>
                <div class="form-group" style="clear:both;">
                  <label>Choose Location for ${this.group.name}</label>
                  <select is="location-select" class="form-control" data-group_id="${this.group.id}"></select>
                </div>
                <div class="form-group" style="overflow:auto;">
                  <a id="add-location-save" type="submit" value='Move Location' class='btn btn-primary pull-right detail-row-button' style="min-width:0">Move Location</a><a data-dismiss="modal" class='btn btn-outline-secondary pull-right detail-row-button'>Cancel</a>
                </div>
              </div>
            </div>`

    this.querySelector("#add-location-save").addEventListener("click", function() {
      let errors = "";
      let location_id = this.querySelector("select").value
      if(location_id == "null") {
        errors += `<div class="alert alert-danger alert-dismissible" role="alert">
          <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          <strong>Warning!</strong> Please select a location.
        </div>`;
      }

      if(errors.length > 0) {
        this.querySelector(".errors").innerHTML = errors;
        return;
      }

      $(this).find('.modal').modal('hide');
      this.addExistingLocation(location_id);
    }.bind(this));
  }
}

customElements.define("add-location-modal", AddLocationModal);